<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator />
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <breadcrumbNavigationBar :data="breadcrumbNavigationBarData"></breadcrumbNavigationBar>
              </el-col>
            </el-row>
            <el-row>
              <el-col>&nbsp;</el-col>
            </el-row>
            <div v-loading="isLoadingStudent">
              <el-row type="flex" class="student-container">
                <el-col :span="16">
                  <studentInfo mode="mini" :enableEdit="!readonly" :dataIn="studentInfoDataIn" @change="onStudentInfoChange" />
                </el-col>
              </el-row>
              <el-divider />
              <div v-loading="isLoading">
                <taskAssignmentServiceCard v-for="(service, index) in workflowServiceList" :key="index" :isReadonly="readonly" :employeeList="employeeList"
                  :dataIn="service" @saved="onTaskAssignmentServiceCardSaved" />
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { ObjectEx } from "vue-objectex";

import {
  getSAEmployees,
  getStudyAbroadStudent,
  getSAStudentWorkflowServiceList,
} from "@/service/studyAbroad.service";

const defaultSAStudent = {
  StudentId: 0,
  StudentName: null,
  Phone: null,
  SaleAmountDiscountedCAD: 0,
  SaleAmountDiscountedCNY: 0,
  SaleAmountAvailableCAD: 0,
  SaleAmountAvailableCNY: 0,
  WorkflowCurrencyList: [],
  ChannelId: null,
  ChannelName: null,
  ChannelCurrency: null,
};

const mixin_bnBar = {
  components: {
    breadcrumbNavigationBar: () =>
      import("@/components/common/breadcrumbNavigationBar"),
  },
  data() {
    return {
      navName: "分配详情",
      breadcrumbNavigationBarData: new ObjectEx(
        [
          {
            key: "name",
            value: "真留",
          },
          {
            key: "currentName",
            value: this.$route.meta.navName,
          },
          {
            key: "navList",
            value: [
              {
                link: "/studyAbroad/taskAssignment",
                name: "真留任务分配",
              },
            ],
          },
        ],
        {
          updateCurrentName(newValue) {
            this.currentName = newValue;
          },
          updateNavList(newNavList) {
            this.navList = newNavList;
          },
        }
      ),
    };
  },
  created() {
    this.$nextTick(() => {
      if (!!this.$route.meta.navName) {
        this.navName = this.$route.meta.navName;
        this.breadcrumbNavigationBarData.updateCurrentName(this.navName);
      }
      this.updateNavListByRoute();
    });
  },
  methods: {
    updateNavListByRoute() {
      let navList = [];
      try {
        navList = this.$cryptoJS.enc.Base64.decode(this.routeQuery.navList);
        navList = JSON.parse(navList);
      } catch (error) {}
      if (Object.typeOf(navList) !== "array") return;

      let bnbNavList = [];
      navList.forEach((nav) => {
        let name;
        switch (nav.path) {
          case "/studyAbroad/taskAssignment":
            name = "真留任务分配";
            break;
        }

        if (!!name) {
          if (bnbNavList.length === 0) this.$route.meta.menuActive = nav.path;
          bnbNavList.push({
            basePath: nav.path,
            link: nav.path,
            name,
            data: nav.data,
          });
        }
      });
      this.breadcrumbNavigationBarData.updateNavList(bnbNavList);
    },
  },
};

export default {
  name: "taskAssignmentDetail",
  mixins: [mixin_bnBar],
  components: {
    navigator: () => import("@/components/navigator"),
    studentInfo: () => import("@/components/studyAbroad/studentInfo"),
    taskAssignmentServiceCard: () =>
      import("@/components/studyAbroad/taskAssignmentServiceCard"),
  },
  data() {
    return {
      readonly: this.USERMANAGER.isSAFinancialAssistant,
      routeQuery: {},
      isLoading: false,
      isLoadingStudent: false,
      studentId: 0,
      employeeList: [],
      saStudent: Object.clone(defaultSAStudent),
      studentInfoDataIn: {
        studentId: 0,
        studentData: null,
      },
      workflowServiceList: [],
    };
  },
  created() {
    this.routeQuery = this.$route.query;
    switch (this.$route.path) {
      default:
        this.studentId = `${this.routeQuery.studentId}`.toNumber();
        break;
    }

    this.init();
  },
  methods: {
    // 从服务端获取数据相关方法
    async loadSAStudentFromServer() {
      if (!this.studentId) return;
      this.isLoadingStudent = true;
      try {
        let result = await getStudyAbroadStudent(this.studentId);
        this.saStudent =
          !!result && result.success && !!result.data
            ? result.data
            : Object.clone(defaultSAStudent);
      } catch (error) {
      } finally {
        this.isLoadingStudent = false;
      }
    },
    async loadSAEmployeeListFromServer() {
      let dataList = [
        {
          Id: null,
          Name: "未分配",
        },
      ];

      this.isLoading = true;
      let roleTypes = [
        this.GLOBAL.roleType.saBusinessManager,
        this.GLOBAL.roleType.saBusinessAssistant,
      ];
      try {
        let result = await getSAEmployees(roleTypes, "", null);
        if (result && result.success) {
          let employeeList = result.data.Results.map((i) => {
            return {
              Id: i.UserId,
              Name: i.Name,
              ResponsibleStudentCount: i.ResponsibleStudentCount,
            };
          });
          dataList = dataList.concat(employeeList);
        }
      } catch (error) {
      } finally {
        this.isLoading = false;
      }

      this.employeeList = dataList;
    },
    async loadSAStudentWorkflowServiceListFromServer() {
      if (!this.studentId) {
        this.workflowServiceList = [];
        return;
      }

      try {
        let result = await getSAStudentWorkflowServiceList(this.studentId);
        if (!!result && result.success) {
          this.workflowServiceList = result.data;
        }
      } catch (error) {}
    },
    async init() {
      await this.loadSAStudentFromServer();
      await this.loadSAEmployeeListFromServer();
      await this.loadSAStudentWorkflowServiceListFromServer();
    },

    // StudentInfo相关方法
    resetStudentInfoDataIn() {
      let studentData =
        !!this.saStudent && !!this.saStudent.StudentId ? this.saStudent : null;

      this.studentInfoDataIn = {
        studentId: !!studentData ? studentData.StudentId : this.studentId,
        studentData: studentData,
      };
    },
    onStudentInfoChange() {},

    onTaskAssignmentServiceCardSaved(dataOut) {
      this.$nextTick(async () => {
        await this.loadSAEmployeeListFromServer();
        await this.loadSAStudentWorkflowServiceListFromServer();
      });
    },
  },
  watch: {
    saStudent(newValue) {
      this.resetStudentInfoDataIn();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/page/studyAbroad/taskAssignmentDetail.vue